import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ContactFooter() {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#1a1a2e] text-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#FF6B6B]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#4ECDC4]/5 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-8 pb-8 border-b border-white/10">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] flex items-center justify-center">
              <i className="ri-luggage-cart-line text-white text-lg"></i>
            </div>
            <span className="text-lg font-bold" style={{ fontFamily: 'Poppins, sans-serif' }}>
              AIR BAGGAGE<span className="text-[#FF6B6B]"> REPAIR SOLUTIONS</span>
            </span>
          </Link>

          <div className="flex items-center gap-6 text-sm text-white/60">
            <Link to="/" className="hover:text-white transition-colors cursor-pointer">
              {t('nav.home')}
            </Link>
            <Link to="/contact" className="hover:text-white transition-colors cursor-pointer">
              {t('nav.contact')}
            </Link>
          </div>

          <div className="flex gap-3">
            {[
              { icon: 'ri-linkedin-fill', color: 'from-[#0077B5] to-[#00A0DC]' },
              { icon: 'ri-facebook-fill', color: 'from-[#1877F2] to-[#42B72A]' },
            ].map((social, index) => (
              <a
                key={index}
                href="#"
                className={`w-9 h-9 bg-gradient-to-br ${social.color} rounded-lg flex items-center justify-center hover:scale-110 transition-transform cursor-pointer`}
                aria-label={social.icon.replace('ri-', '').replace('-fill', '')}
              >
                <i className={`${social.icon} text-white text-sm`}></i>
              </a>
            ))}
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            &copy; 2025 Air Baggage Repair Solutions. {t('footer.copyright')}
          </p>
          <div className="flex items-center gap-6 text-xs text-white/40">
            <a href="#" className="hover:text-white transition-colors">
              {t('footer.privacy')}
            </a>
            <a href="#" className="hover:text-white transition-colors">
              {t('footer.terms')}
            </a>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="hover:text-white transition-colors"
            >
              {t('footer.poweredBy')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
